"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var _kernel_store_types_1 = require("../../types");
var _kernel_container_1 = __importDefault(require("../../../container"));
var startDownloadNextRequiredMediafile_1 = __importDefault(require("./startDownloadNextRequiredMediafile"));
var mediafiles_1 = require("../../stores/mediafiles");
var point_1 = require("../../selectors/point");
var mediafilesMeta_1 = require("../../stores/mediafilesMeta");
var checkUpcomingGenerationIsReady_1 = __importDefault(require("../generation/checkUpcomingGenerationIsReady"));
var global_1 = require("../../stores/global");
var mediafilesMeta_2 = require("../../selectors/mediafilesMeta");
var fetchMediafileData_1 = __importDefault(require("./fetchMediafileData"));
var recalcMediafileCrc_1 = __importDefault(require("./recalcMediafileCrc"));
function downloadFile(file) {
    var _this = this;
    var action = function (dispatch, getState) { return __awaiter(_this, void 0, void 0, function () {
        var logger, fs, timer, settings, mediafileDownloadTimeout, mediafileRefetchIteration, mediafileRecalcIteration, speedLimit, temporaryFilepath, persistentFilepath, uri, crcValid, fileSize, delay, err_1, _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    logger = _kernel_container_1.default.get("LOGGING").getLogger("@kernel/downloadFile");
                    fs = _kernel_container_1.default.get("FILESYSTEM");
                    timer = _kernel_container_1.default.get("TIMER");
                    settings = _kernel_container_1.default.get("SETTINGS");
                    mediafileDownloadTimeout = settings.getSetting("MEDIAFILE_DOWNLOAD_TIMEOUT", 500);
                    mediafileRefetchIteration = settings.getSetting("MEDIAFILE_ERROR_REFETCH_ITERATION", 3);
                    mediafileRecalcIteration = settings.getSetting("MEDIAFILE_ERROR_RECALC_ITERATION", 5);
                    dispatch((0, mediafiles_1.setFileCacheState)(file.mediafileId, file.filename, _kernel_store_types_1.EMediafileCacheState.DOWNLOADING));
                    speedLimit = (0, point_1.selectCurrentSpeedLimit)(getState());
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 11, , 14]);
                    temporaryFilepath = fs.getFileTemporaryFilepath(file.filename);
                    persistentFilepath = fs.getFileLocalFilepath(file.filename);
                    return [4, fs.getFileCDNUri(file.filename, speedLimit)];
                case 2:
                    uri = _d.sent();
                    return [4, fs.downloadFile(uri, temporaryFilepath)];
                case 3:
                    _d.sent();
                    crcValid = void 0;
                    if (!file.crcHash) return [3, 5];
                    return [4, fs.validateFileCrcHash(temporaryFilepath, file.crcHash)];
                case 4:
                    crcValid = _d.sent();
                    return [3, 6];
                case 5:
                    crcValid = true;
                    _d.label = 6;
                case 6:
                    if (!crcValid) return [3, 9];
                    return [4, fs.renameFile(temporaryFilepath, persistentFilepath)];
                case 7:
                    _d.sent();
                    dispatch((0, mediafiles_1.setFileCacheState)(file.mediafileId, file.filename, _kernel_store_types_1.EMediafileCacheState.CACHE));
                    logger.info("Downloaded file", __assign({}, file));
                    return [4, fs.getFileCacheSize(persistentFilepath)];
                case 8:
                    fileSize = _d.sent();
                    dispatch((0, global_1.addToTotalMediafilesSize)(fileSize));
                    dispatch((0, mediafilesMeta_1.removeMediafileFromCurrentlyDownloading)(file.mediafileId));
                    dispatch((0, checkUpcomingGenerationIsReady_1.default)());
                    return [3, 10];
                case 9:
                    logger.warn("Failed to download mediafile", __assign({}, file));
                    delay = (0, mediafilesMeta_2.selectMediafileDownloadDelay)(getState(), file.mediafileId);
                    if (delay) {
                        if (delay.iteration === mediafileRefetchIteration) {
                            logger.warn("Refetching mediafile data", __assign({}, file));
                            dispatch((0, fetchMediafileData_1.default)(file.mediafileId));
                        }
                        else if (delay.iteration === mediafileRecalcIteration) {
                            logger.warn("Forcing mediafile crc recalculation", __assign({}, file));
                            dispatch((0, recalcMediafileCrc_1.default)(file.mediafileId));
                        }
                    }
                    throw new Error("Crc mismatch");
                case 10: return [3, 14];
                case 11:
                    err_1 = _d.sent();
                    dispatch((0, mediafiles_1.setFileCacheState)(file.mediafileId, file.filename, _kernel_store_types_1.EMediafileCacheState.NO_CACHE));
                    _a = dispatch;
                    _b = mediafilesMeta_1.updateMediafileDownloadDelay;
                    _c = [file.mediafileId];
                    return [4, fs.getDownloadDelayFromError(err_1.toString())];
                case 12:
                    _c = _c.concat([_d.sent()]);
                    return [4, fs.shouldErrorIncreaseDelay(err_1.toString())];
                case 13:
                    _a.apply(void 0, [_b.apply(void 0, _c.concat([_d.sent()]))]);
                    return [3, 14];
                case 14:
                    timer.setTimeout(function () {
                        dispatch((0, startDownloadNextRequiredMediafile_1.default)());
                    }, mediafileDownloadTimeout);
                    dispatch({ type: downloadFile.type, payload: { file: file } });
                    return [2];
            }
        });
    }); };
    action.type = downloadFile.type;
    return action;
}
exports.default = downloadFile;
downloadFile.type = "downloadFile";
//# sourceMappingURL=downloadFile.js.map